/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef, useState} from 'react'
import ApexCharts, {ApexOptions} from 'apexcharts'
import {KTSVG} from '../../../helpers'
import {Dropdown1} from '../../content/dropdown/Dropdown1'
import {getCSS, getCSSVariableValue} from '../../../assets/ts/_utils'
import {useThemeMode} from '../../layout/theme-mode/ThemeModeProvider'
import {GetSaleReportChart} from "../../../../app/pages/dashboard/core/Request";
import {ChartReportModel} from "../../../../app/pages/dashboard/core/model";
import {SwalError} from "../../../helpers/components/Swal";

type Props = {
  className: string
}

const ChartsWidget1: React.FC<Props> = ({className}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const [day,setDay] = useState<number>(7)
  const [loading,setLoading] = useState(false)
  const [data,setData] = useState<ChartReportModel[]>()
  const {mode} = useThemeMode()
  useEffect(()=>{
    bind()
  },[])
  useEffect(() => {
    const chart = refreshChart()

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [data])
  useEffect(()=>{
    bind()
  },[day])
  const refreshChart = () => {
    if (!chartRef.current) {
      return
    }
    const height = parseInt(getCSS(chartRef.current, 'height'))
    const chart = new ApexCharts(chartRef.current, getChartOptions(height,data ? data?.flatMap(p=>p.value) : [],data ? data?.flatMap(p=>p.key):[]))
    if (chart) {
      chart.render()
    }
    return chart
  }
  const bind =async () =>{
    try {
      setLoading(true)
      const {data:response} = await GetSaleReportChart(day)
      setData(response)
      setLoading(false)
    }catch (err:any){
      setLoading(false)
      SwalError(err?.response?.data?.message)
    }
  }


  return (
      <div className={`${loading && 'overlay overlay-block '} rounded`}>
        <div className="overlay-wrapper p-5">
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        {/* begin::Title */}
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>گزارش فروش</span>

          <span className='text-muted fw-semibold fs-7'>گزارش نموداری فروش </span>
        </h3>
        {/* end::Title */}

        {/* begin::Toolbar */}
        <div className='card-toolbar' data-kt-buttons='true'>
          <a
              onClick={()=>{
                setDay(365)
              }}
              className={`btn btn-sm btn-color-muted btn-active btn-active-primary  px-4 me-1 ${day === 365 && 'active'}`}
              id='kt_charts_widget_2_year_btn'
          >
            سالانه
          </a>
          <a
              onClick={()=>{
                setDay(180)
              }}
              className={`btn btn-sm btn-color-muted btn-active btn-active-primary  px-4 me-1 ${day === 180 && 'active'}`}
              id='kt_charts_widget_2_month_btn'
          >
            6 ماهه
          </a>
          <a
              onClick={()=>{
                setDay(90)
              }}
              className={`btn btn-sm btn-color-muted btn-active btn-active-primary  px-4 me-1 ${day === 90 && 'active'}`}
              id='kt_charts_widget_2_month_btn'
          >
            3 ماهه
          </a>

          <a
              onClick={()=>{
                setDay(7)
              }}
              className={`btn btn-sm btn-color-muted btn-active btn-active-primary  px-4 me-1 ${day === 7 && 'active'}`}
              id='kt_charts_widget_2_week_btn'
          >
            هفتگی
          </a>
        </div>
        {/* end::Toolbar */}
      </div>
      {/* end::Header */}

      {/* begin::Body */}

      <div className='card-body'>
        {/* begin::Chart */}

        <div ref={chartRef} id='kt_charts_widget_1_chart' style={{height: '350px'}} />
        {/* end::Chart */}
      </div>
      {/* end::Body */}
    </div>
          {loading && (
              <div className="overlay-layer rounded bg-dark bg-opacity-5">
                <div
                    className="spinner-border text-primary"
                    role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
          )}
        </div>
      </div>
  )
}

export {ChartsWidget1}

function getChartOptions(height: number,Value? : number[],Label? : string[]): ApexOptions {
  const labelColor = getCSSVariableValue('--kt-gray-500')
  const borderColor = getCSSVariableValue('--kt-gray-200')
  const baseColor = getCSSVariableValue('--kt-primary')
  const secondaryColor = getCSSVariableValue('--kt-gray-300')

  return {
    series: [
      {
        name: 'فروش',
        data: Value || [],
      }
    ],
    chart: {
      fontFamily: 'inherit',
      type: 'bar',
      height: height,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '30%',
        borderRadius: 5,
      },
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: Label,
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    fill: {
      opacity: 1,
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
          value: 0,
        },
      },
    },
    tooltip: {
      style: {
        fontSize: '12px',
      },
      y: {
        formatter: function (val) {
          return '$' + val.toLocaleString() + ' ریال'
        },
      },
    },
    colors: [baseColor, secondaryColor],
    grid: {
      borderColor: borderColor,
      strokeDashArray: 4,
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
  }
}
